module.exports = __webpack_public_path__ + "public/images/icon-tiktok.a7bdaf0a9d76069a3a0c6ce9a7c2ffad.svg";